module.exports = __webpack_public_path__ + "static/media/logistics.8640d6e6.jpeg";